import React from 'react';

import Container from '@src/components/Shared/Container';
import SectionHeader from '@src/components/Shared/SectionHeader';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';
import NextImage from '@src/components/Shared/NextImage';

import { HeroPrimaryPropTypes } from './HeroPrimary.types';

const HeroPrimary: React.FC<HeroPrimaryPropTypes> = ({
  attr,
  id,
  className,
  title,
  titleClassName,
  imgClassName,
  imgSrc,
  bodyCopy,
  bodyCopyClassName = '',
  childrenClassName,
}) => {
  return (
    <Container
      attr={attr}
      id={id}
      className={`relative bg-primary py-[4rem] lg:py-[6rem] 2xl:py-[9rem] ${className}`}
    >
      <SectionHeader
        className='relative z-1 items-start xsm:items-center md:items-start'
        titleHighlightBold
        title={title}
        titleClassName={`text-body-copy--light text-left xsm:text-center md:text-left mb-[3.2rem] ${titleClassName}`}
        align='left'
        childrenClassName={`text-body-copy--light text-left xsm:text-center md:text-left md:text-left max-w-[38rem] xsm:max-w-[33rem] md:max-w-full ${childrenClassName}`}
        headingLevel='h1'
      >
        <RenderBodyCopy bodyCopy={bodyCopy?.json?.content} className={`${bodyCopyClassName}`} />
      </SectionHeader>
      {imgSrc && <NextImage className={`${imgClassName}`} src={imgSrc} alt='VALD Health Logo' />}
    </Container>
  );
};

export default HeroPrimary;
